import { Grid, Box, Button } from "@mui/material"
import Typography from "@mui/material/Typography"
import TextField from "@mui/material/TextField"
import { Stack, CircularProgress, Modal } from "@mui/material"

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 20,
    p: 4,
    minWidth: 400,
    maxWidth: 400,
    borderRadius: 3,
    position: "relative"
};

export default function DatePaymentModal({
    openDatePayment,
    handleCloseDatePayment,
    spinerModalDatePayment,
    msgDangerModalDatePayment,
    datePaymentValue,
    setDatePaymentValue,
    saveDatePayment,
    transactionId
}) {
    return (
        <Modal
            open={openDatePayment}
            onClose={handleCloseDatePayment}
            aria-labelledby="modal-date-payment-title"
            aria-describedby="modal-date-payment-description"
            className="text-center"
        >
            <Box sx={style}>
                <Typography id="modal-date-payment-title" variant="h6" component="h2">
                    Registrar Fecha de Pago
                </Typography>
                {!spinerModalDatePayment && (
                    <>
                        <Typography id="modal-date-payment-description" sx={{ mt: 2 }}>
                            Seleccione la fecha de pago para la factura:
                        </Typography>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <div className="mt-2">
                                    <TextField
                                        name="datePayment"
                                        label="Fecha de Pago"
                                        variant="outlined"
                                        type="date"
                                        format="dd/MM/yyyy"
                                        fullWidth
                                        onChange={(e) => setDatePaymentValue(e.target.value)}
                                        value={datePaymentValue || ""}
                                        InputLabelProps={{ shrink: true }}
                                        size="small"
                                    />
                                </div>
                            </Grid>
                        </Grid>
                        {msgDangerModalDatePayment && (
                            <Grid item xs={12} mt={4}>
                                <Box className="alert-danger">
                                    {msgDangerModalDatePayment.map((item, index) => (
                                        <span key={index}>{item} <br /></span>
                                    ))}
                                </Box>
                            </Grid>
                        )}
                        <Stack direction="row" justifyContent="space-between" mt={4}>
                            <div style={{ display: "flex", justifyContent: "flex-end", width: "100%", gap: 16 }}>
                                <div style={{ width: "50%" }}>
                                    <Button
                                        onClick={handleCloseDatePayment}
                                        variant="contained"
                                        className="MuiButton-containedCancel"
                                        fullWidth
                                    >
                                        Cancelar
                                    </Button>
                                </div>
                                <div style={{ width: "50%" }}>
                                    <Button
                                        onClick={() => saveDatePayment(transactionId, datePaymentValue)}
                                        color="primary"
                                        variant="contained"
                                        fullWidth
                                        disabled={!datePaymentValue}
                                    >
                                        Guardar
                                    </Button>
                                </div>
                            </div>
                        </Stack>
                    </>
                )}
                {spinerModalDatePayment && (
                    <>
                        <br />
                        <br />
                        <br />
                        <CircularProgress color="success" />
                        <br />
                        <br />
                        <br />
                    </>
                )}
            </Box>
        </Modal>
    );
}
